import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { transactionDetailLabels } from '../../utilities/Constants';

export interface StandingAuthorizationCard {
  id: string;
  title: string;
  subtitle?: string;
  details?: string[];
  selected?: boolean;
}

@Component({
  standalone: false,
  selector: 'mm-standing-authorization-card-container',
  templateUrl: './standing-authorization-card-container.component.html',
  styleUrls: ['./standing-authorization-card-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StandingAuthorizationCardContainerComponent {
  @Input() label = '';
  @Input() authorizationCount = 0;
  @Input() cards: StandingAuthorizationCard[] = [];
  @Input() isWireTemplateView = false;
  @Input() disabled = false;

  @Output() cardSelected = new EventEmitter<string>();
  readonly labels = transactionDetailLabels;

  onSelectCard(cardId: string): void {
    this.cardSelected.emit(cardId);
  }

  get templatesCountMessage(): string {
    if (this.isWireTemplateView) {
      return this.labels.templatesFound;
    }

    return this.labels.standingAuthorizationsFound;
  }
}
